import WeaDriver from "./driver"

window.WeaDriver = WeaDriver;

export default WeaDriver;